import { render, staticRenderFns } from "./HelpButton.vue?vue&type=template&id=420754b6&scoped=true"
import script from "./HelpButton.vue?vue&type=script&lang=js"
export * from "./HelpButton.vue?vue&type=script&lang=js"
import style0 from "./HelpButton.vue?vue&type=style&index=0&id=420754b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420754b6",
  null
  
)

export default component.exports